import {AfterViewChecked, Component, ElementRef, Inject, OnDestroy, ViewChild} from '@angular/core';
import {MatTableDataSource, MatTableModule} from "@angular/material/table";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {Router} from "@angular/router";
import {FirebaseService} from "../../services/firebase.service";
import {getLongAuthorName} from "../../common/service-functions";
import {Subscription} from "rxjs";
import {WINDOW} from "../../window";
import {HostService} from "../../services/host.service";

@Component({
  selector: 'app-authors-table',
  standalone: true,
  imports: [MatTableModule, MatSortModule],
  templateUrl: './authors-table.component.html',
  styleUrl: './authors-table.component.sass'
})
export class AuthorsTableComponent implements OnDestroy, AfterViewChecked {
  displayedColumns: string[] = ['name', 'researchArea', 'country'];
  @ViewChild(MatSort) sort : MatSort | null = null;
  @ViewChild('contentToScroll') contentToScroll!: ElementRef;
  $dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  authorsSubscription: Subscription;
  private host: string | null = null;
  private previousHeight: number = 0;
  private readonly targetWindow;


  constructor(private router: Router, firebaseService: FirebaseService, @Inject(WINDOW) private window: Window | null,
              private hostService: HostService) {
    const host = hostService.host;
    if (host && /^https:\/\/[\w-]{0,25}\.?bashanfoundation\.\w{2,4}/.test(host)) {
      this.host = host;
    }
    if (window !== null) {
      this.targetWindow = window.parent;
    }
    this.authorsSubscription = firebaseService.authorsList.subscribe((authors) => {
      this.$dataSource = new MatTableDataSource(Array.from(authors.entries()).map(([id, author]) => {
        const longName = getLongAuthorName(author.names);
        return{
          id,
          name: longName,
          researchArea: author.researchArea,
          country: author.country,
          slug: author.slug,
        };
      }));
      setTimeout(() => {
        if (this.sort) {
          this.sort.active = 'name';
          this.sort.direction = 'asc';
          this.$dataSource.sort = this.sort;
        }
      });
    });

  }

  onRowClick(slug: string): void {
    this.router.navigate([`/author/${slug}`]);
  }

  ngOnDestroy(): void {
    if (this.authorsSubscription) {
      this.authorsSubscription.unsubscribe();
    }
  }

  ngAfterViewChecked(): void {
    this.calculateWindow();
    this.sendMessageToContainer({
      setUrlObj: {
        authorData: {},
        title: `Bashan Foundation Members`,
        url: `/authorsList`
      }
    })
  }

  private calculateWindow() {
    let c = this.contentToScroll.nativeElement.parentElement.parentElement.parentElement;
    let d = this.contentToScroll.nativeElement.parentElement.parentElement;
    let e = this.contentToScroll.nativeElement.parentElement;
    let currentContentHeight: number = this.contentToScroll.nativeElement.offsetHeight;
    // console.log('currentContentHeight1:', c.offsetHeight, d.offsetHeight, e.offsetHeight, this.previousHeight, currentContentHeight);

    if (currentContentHeight !== this.previousHeight ) {
      const newHeight = currentContentHeight + 100;
      e.style.height = `${newHeight}px`;
      d.style.height = `${newHeight}px`;
      c.style.height = `${newHeight}px`;
      // console.log('currentContentHeight:', c.offsetHeight, d.offsetHeight, e.offsetHeight, this.previousHeight, currentContentHeight);

      this.previousHeight = newHeight;
      const message = {
        contentHeight: newHeight
      };

      this.sendMessageToContainer(message);
    }
  }

  private sendMessageToContainer(message: any) {
    if (!this.targetWindow) {
      console.error('Target window not set');
      return;
    }
    if (this.host) {
      this.targetWindow.postMessage(message, this.host);
    }
  }
}
